import React, { createContext, Component } from 'react';

export const SalesContext = createContext({
    planData: {},
    formData: {}
});

export class SalesProvider extends Component {
    state = {
        planData: {
            activeAddPlans: [],
            activePlan: null,
            additionalTotal: 0,
            plan: 'monthly',
            planTotal: 0,
            selectedAddPlans: [],
            selectedPlan: {}
        },
        formData: {
            invitationNumber: '0',
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            serviceAddress: {
                address1: '',
                address2: '',
                city: '',
                state: 'NJ',
                zip: '',
                stateId: 39
            },
            mailingAddress: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                stateId: ''
            },
            billingAddress: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                stateId: ''
            },
            doNotSolicit: null,
            serviceAsMailingAddress: true,
            billingAsServiceAddress: true,
            planDocuments: ''
        },
        termsAndCondition: false,
        promocodeObj: null,
        isPromoApplied: false,
        isAgent: false,
        taxRate: 0.06625,
        contract: {},
        deviceData: {
            activePlan: {},
            deviceInfo: [],
            planPrice: null,
            selectedPlan: '',
            zip: '',
            taxAmount: null
        }
    };

    render() {
        return (
            <SalesContext.Provider
                value={{
                    // DATA
                    data: this.state,

                    // METHODS
                    updatePlanData: (p) => {
                        this.setState({
                            planData: p
                        });
                    },
                    updateFormData: (f) => {
                        this.setState({
                            formData: f
                        });
                    },
                    updateTermsAndCondition: (t) => {
                        this.setState({
                            termsAndCondition: t
                        });
                    },
                    updatePromoCode: (p) => {
                        this.setState({
                            promocodeObj: p,
                            isPromoApplied: p != null
                        });
                    },
                    updateIsAgent: (t) => {
                        this.setState({
                            isAgent: t
                        });
                    },
                    updateDeviceData: (data) => {
                        this.setState({
                            deviceData: data
                        });
                    },
                    updateContract: (data) => {
                        this.setState({
                            contract: data
                        });
                    }
                }}
            >
                {this.props.children}
            </SalesContext.Provider>
        );
    }
}
